module.exports = __webpack_public_path__ + "img/rest-work.ac83649f.png";